<template>
    <main class="content-wrap">
        <div class="content-container">
            <div class="intro row glasovanja" id="glasovanje">
                <div class="col-10" v-if="renderFirstPage">
                    <h1 class="caption" v-cloak>
                        {{ this.polldata['caption1']}}
                    </h1>
                    <div class="bookshelf">
                        <div class="img-container">
                            <div class="img-container-item"  v-for="(path, key, index) in this.polldata['vote_images']" :key="key">
                                <img :class="`uc-image ${images[index + 1]['imageClass']} ${images[index + 1]['position']}`" :src="path" @click="setImagePosition(index + 1)" :alt="key">
                            </div>
                        </div>
                    </div>
                    <div class="steps">
                    </div>
                    <button class="first-button" :disabled="!areAllImagesChosen" type="button" @click="userConfirmedImageOrder" v-cloak>{{ buttonTitle }}</button>
                </div>
                <div class="col-10" v-else-if="renderSecondPage">
                    <h1 class="caption">
                        {{ this.polldata['caption2']}}
                    </h1>
                    <div class="titles">
                        <div class="title" v-for="(title, key) in this.polldata['vote_titles']" :key="key">
                            <input type="radio" :id="key" :v-model="polldata['vote_titles'][key]" name="naslov" @click="setTitle(title, key)">
                            <label :class="selectedTitleId === key ? 'active' : ''" :for="key" v-cloak>{{ title }}</label>
                        </div>
                        <div class="custom-title" >
                            <input type="text" :v-model="selectedTitle" name="naslov" @change="setTitle">
                            <label>Če želite, lahko vpišete še svoj (dodatni) predlog za naslov novega učbenika za zgodovino.</label>
                        </div>
                    </div>
                    <form id="glasovanje-form" method="post">
                        <button class="second-button" type="button" @click="submitFinalResults" v-cloak>
                            {{ buttonTitle }}
                        </button>
                        <div class="error-message" v-if="errorMessage !== ''" v-cloak>{{ errorMessage }}</div>
                    </form>
                    <br>
                    <div class="thanks" v-if="voteSent && errorMessage === ''">
                        <div class="potrditev" v-cloak>
                            Hvala. Učbenik <span>{{ selectedTitle }}</span> je za vas PRAVA IZBIRA. Veselimo se izida <strong>spomladi 2022</strong>.
                        </div>
                        <br>
                        <img class="izbrana-slika" :src="firstPlacedImagePath" alt="slika st. ena">
                        <br>
                        <div class="soglasje">
                            <div class="orange"><strong>Ste že posodobili svoje soglasje za obveščanje?</strong></div>
                            <div>Ostanite v stiku z nami in si zagotovite prejemanje aktualnih novic, obvestil, novosti in dogodkov na področju izobraževanja.</div>
                            <div>Obrazec lahko izpolnite <a href="https://survey.alchemer.eu/s3/90242044/gdpr20" target="_blank">TUKAJ</a></div>
                        </div>
                    </div>
                </div>
                <div class="glasovanje-zakljuceno" v-else>
                    <h1>Glasovanje je zaključeno.</h1>
                    <h1>Hvala za razumevanje.</h1>

                </div>
            </div>
        </div>
    </main>
</template>

<script>

export default {
    props: ['email', 'polldata'],
    data() {
        return {
            alreadyVoted: false,
            nextPosition: 1,
            notTakenPositions: [1,2,3],
            buttonTitle: "Potrdi izbrano",
            images: { 
                1: { id: 1, isChosen: false, position: "", imageClass: "one" },
                2: { id: 2, isChosen: false, position: "", imageClass: "two" },
                3: { id: 3, isChosen: false, position: "", imageClass: "three" }
            },
            positionClass: {
                0: "",
                1: "first",
                2: "second",
                3: "third",
                "": 0,
                "first": 1,
                "second": 2,
                "third": 3,
            },
            page: 1,
            selectedTitle: "",
            selectedTitleId: null,
            errorMessage: "",
            voteSent: false,
            loading: false
        }
    },
    mounted() {
        $("#glasovanje-body #footer > .ui.container").append("<img src='/images/glasovanja/modrijan-logo.png' class='Modrijan logo'/>");
        if (this.$cookies.isKey(this.polldata['pollId'])) {
            this.alreadyVoted = true;
        }
        if (new Date() > new Date(this.polldata["zakljucek_glasovanja"])) {
            this.page = 0;
        }

    },
    methods: {
        setImagePosition(nr) {
            if (isNaN(nr)) {
                return console.log("Image not available: " + nr);
            }
            if (this.images[nr] && this.images[nr]["isChosen"]) {
                this.notTakenPositions.push(this.positionClass[this.images[nr]["position"]]);
                this.images[nr] = { isChosen: false, position: "", imageClass: this.images[nr]["imageClass"]};
                this.nextPosition = +this.notTakenPositions.sort()[0];
            } else if (this.images[nr] && !this.images[nr]["isChosen"]) {
                this.images[nr] = { isChosen: true, position: this.positionClass[this.nextPosition], imageClass: this.images[nr]["imageClass"] };
                this.notTakenPositions.splice(this.notTakenPositions.indexOf(this.nextPosition), 1);
                this.nextPosition = +this.notTakenPositions[0];
            }
        },
        setTitle(title, key) {
            if (typeof title === "string") {
                this.selectedTitle = title
                this.selectedTitleId = key;
                return this.buttonTitle = "Potrdi";
            }
            this.selectedTitle = title.target.value
            this.selectedTitleId = title.target.id;
            return this.buttonTitle = "Potrdi";
        },
        userConfirmedImageOrder() {
            this.buttonTitle = "Potrdi";
            return this.page = 2;
        },
        submitFinalResults(e) {
            e.preventDefault();
            if (this.selectedTitle === "") {
                return this.errorMessage = "Najprej morate izbrati ali vpisati svoj naslov!";
            }
            if (this.alreadyVoted) {                
                 return this.errorMessage = "Ste že glasovali, glasujete lahko samo enkrat.";
            }

            this.errorMessage = "";
            this.loading = true;
            return axios.post(this.route('glasovanja.vote', this.polldata['pollId']), {
                email: this.email || null,
                app: this.polldata['app'],
                poll: this.polldata['pollId'],
                results: [ {
                    "images": Object.keys(this.images).map(key => ({
                        "id": `image${key}`,
                        "type": "image",
                        "position": this.positionClass[this.images[key].position],
                        "path": this.polldata['vote_images'][`image${key}`]
                    })),
                    "titles": [{ 
                        "id": this.selectedTitleId, 
                        "title": this.selectedTitle, 
                        "type": "title"
                    }]
                } ],
                zakljucek_glasovanja: this.polldata['zakljucek_glasovanja'],
                format_datuma_zakljucka: this.polldata["format_datuma_zakljucka"]
            }).then((response) => {
                this.loading = false;
                if (response.data && response.data.status === "ok") {
                    this.buttonTitle = "Hvala za vaš glas!";
                    this.voteSent = true;
				    this.$cookies.set(this.polldata['pollId'], true, 60 * 60 * 24 * 365);
                    this.alreadyVoted = true;
                    return this.page = 2;
                } else {
                    this.errorMessage = response.data.message;
                    this.voteSent = true;
                    return this.page = 2;
                }
            }).catch(error => {
                console.log("Preveri nastavitve v json datoteki.");
                this.errorMessage = "Pri potrditvi vašega izbora je prišlo do napake. Prosimo poskusite kasneje.";
                this.voteSent = true;
                return this.page = 2;
            });  	
        }
    },
    computed: {
        renderFirstPage() {
            return +this.page === 1;
        },
        renderSecondPage() {
            return +this.page === 2;
        },
        areAllImagesChosen() {
            return this.notTakenPositions.length === 0;
        },
        isTitleSelected() {
            return !!this.selectedTitle;
        },
        firstPlacedImagePath() {
            const firstImagePosition = Object.keys(this.images)
                .map(key => ({
                        place: this.images[key].position,
                        path: this.polldata['vote_images'][`image${key}`]
                    })
                )
                .filter(item => item.place === "first");
            return (firstImagePosition || this.polldata['vote_images'])[0].path;
        }
    }
}

</script>




// WEBPACK FOOTER //
// resources/assets/js/components/Glasovanja.vue